import { xenv as getXenv } from '../xenv';
import { collections } from './api-conf';
const canIUse = (apiName, xenv) => {
    const currentXenv = xenv || getXenv();
    if (apiName in collections) {
        if (Object.prototype.toString.call(collections[apiName]) === '[object Object]') {
            /* 该API区分xenv */
            return collections[apiName][currentXenv] || false;
        }
        else {
            /* 该API不区分xenv */
            return collections[apiName] || false;
        }
    }
    else {
        return false;
    }
};
export { canIUse };
